import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared-module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '@core/layout/header/header.component';
import { SidebarComponent } from '@core/layout/sidebar/sidebar.component';
import { UserProfileModalComponent } from '@core/layout/header/user-profile-modal/user-profile-modal.component';
import { CameraCaptureDialogComponent } from '@core/layout/header/user-profile-modal/camera-capture-dialog/camera-capture-dialog.component';
import { NotificationsPanelComponent } from '@core/layout/header/notifications-panel/notifications-panel.component';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        SharedModule,
        RouterModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        HeaderComponent,
        SidebarComponent,
        UserProfileModalComponent,
        CameraCaptureDialogComponent,
        NotificationsPanelComponent
    ],
    exports: [
        HeaderComponent,
        SidebarComponent,
        TranslateModule
    ]
})
export class CoreModule { }
